import React from "react";

import { LoadingOutlined } from "@ant-design/icons";
import { Table, Switch, TimePicker, Spin, Collapse } from "antd";
import Interweave from "interweave";
import moment from "moment";

import segmentStyles from "../BandConfiguration.module.css"
import styles from "./styles.module.css";
import { useSegmentLogic } from "../hooks";

const { Panel } = Collapse;

const BandSegment = ({
  data,
  cmsData,
  loading,
  onSegmentSelect,
  eventType,
  handleSegmentTimeChange,
}) => {  
  const { error, validateDate, handleSegmentSelect } = useSegmentLogic(handleSegmentTimeChange, onSegmentSelect);
  const MobText = ({text, record}) => (
    <p style={{ paddingLeft: 12 }}>
     <div className={segmentStyles.mob_segment_time}>
          <p>
            <span className={segmentStyles.mob_time}>Timing</span>
            <TimePicker 
              use12Hours
              format="h:mm a"
              value={moment(record?.startTime, "h:mm a")}
              onSelect={(value) => validateDate("startTime", value, record)}
              minuteStep={15}
              popupClassName={styles.segment_tab_timepicker}
              allowClear={false}
              showNow={false}
            />
            <span className={segmentStyles.mob_to}>To</span>
            <TimePicker 
              use12Hours
              format="h:mm a"
              value={moment(record?.endTime, "h:mm a")}
              onSelect={(value) => validateDate("endTime", value, record)}
              minuteStep={15}
              popupClassName={styles.segment_tab_timepicker}
              allowClear={false}
              showNow={false}
            />            
          </p>
          </div>
          <div className={segmentStyles.mob_segment_yes}>
          <p>
            <span className={segmentStyles.mob_time}>Yes/No</span>
          <Switch
          size="small"
          checked={record?.default}
          onChange={(value) => handleSegmentSelect(value, record)}
          disabled={record?.required}
          checkedChildren="Yes"
          unCheckedChildren="No"
          style={{width: "60px"}}
        />
          </p>
          </div>
          <div className={segmentStyles.mob_segment_musician}>
          <p>
            <span className={segmentStyles.mob_time }>Musicians</span>
            <span className={segmentStyles.music_num}>{record?.musicians}</span>
          </p>
          </div>
          <div className={segmentStyles.mob_segment_musician}>
          <p>
            <span className={segmentStyles.mob_time }>Price</span>
            <span className={segmentStyles.music_num}>
               {!!record?.default
                ? !!record?.overtimePrice
                   ? `$${record?.overtimePrice}`
                  : "Included"
                : "Not Included"}
             </span>
          </p>
          </div>
    </p>
  );

  const columns = [
    {
      title: "Segments",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Timing (Times can be TBD)",
      children: [
        {
          dataIndex: "startTime",
          key: "startTime",
          render: (text, record) => (
            <>
              <TimePicker
                use12Hours
                format="h:mm a"
                value={moment(text, "h:mm a")}
                onSelect={(value) => validateDate("startTime", value, record)}
                minuteStep={15}
                popupClassName={styles.segment_tab_timepicker}
                allowClear={false}
                showNow={false}
              />
              <span className={styles.table_to}>to</span>
            </>
          ),
        },
        {
          dataIndex: "endTime",
          key: "endTime",
          render: (text, record) => (
            <TimePicker
              use12Hours
              format="h:mm a"
              value={moment(text, "h:mm a")}
              onSelect={(value) => validateDate("endTime", value, record)}
              minuteStep={15}
              popupClassName={styles.segment_tab_timepicker}
              allowClear={false}
              showNow={false}
            />
          ),
        },
      ],
    },
    {
      title: "Yes/No",
      dataIndex: "default",
      key: "default",
      render: (text, record) => (
        <Switch
          size="small"
          checked={text}
          onChange={(value) => handleSegmentSelect(value, record)}
          disabled={record?.required}
          checkedChildren="Yes"
          unCheckedChildren="No"
          style={{width: "60px"}}
        />
      ),
    },
    {
      title: "Musicians",
      dataIndex: "musicians",
      key: "musicians",
    },
    {
      title: "Price",
      dataIndex: "required",
      key: "required",
      render: (text, record) => (
        <p>
          {!!record?.default
            ? !!record?.overtimePrice
              ? `$${record?.overtimePrice}`
              : "Included"
            : "Not Included"}
        </p>
      ),
    },
  ];

  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center">
        <Spin
          spinning={true}
          style={{ height: "300px", backgroundColor: "transparent" }}
          indicator={
            <LoadingOutlined style={{ fontSize: 32, color: "#29a6ed" }} spin />
          }
        />
      </div>
    );

  return (
    <div className={styles.segment_table_container}>
      <Table
        className={styles.segment_table_content}
        dataSource={data}
        columns={columns}
        pagination={false}
        // rowClassName={(record) => !record.required && "disabled-row"}
      />
    <div className={segmentStyles.mobile_segment_table}>
      <h3 className={segmentStyles.collapse_heading}>Segments</h3>
      <Collapse bordered={false} defaultActiveKey={['1']}>
        <Panel header="On-Site Ceremony" key="1">
        <MobText text={"On-Site Ceremony"} record={data?.[0]} />
        </Panel>
        <Panel header="Cocktail Hour" key="2">
          <MobText text={"Cocktail Hour"} record={data?.[1]} />
        </Panel>
        <Panel header="Reception" key="3">
          <MobText text={"Reception"} record={data?.[2]} />
        </Panel>
      </Collapse>
    </div>
      {eventType?.toLowerCase() === "wedding" && <div className={`d-flex ${styles.segment_notes}`}>
        <p>
          Note<span>*</span>
        </p>
        <p className={styles.note_content}>
          {cmsData?.pricing_segment_instruction !== undefined ?
          <Interweave allowElements={false} content={cmsData?.pricing_segment_instruction} /> 
            : "As a courtesy to our clients, each band includes a designated number of their musicians at Ceremony and Cocktail Hour for no additional fees. When adding a single string player to perform with the band musicians, select only one musician in the Strings section. Adding a string duo or more will remove the band's musicians."}
        </p>
      </div>}
      {error && (
        <p style={{ fontSize: "1rem" }} className="error">
          {error}
        </p>
      )}
    </div>
  );
};

export default BandSegment;
